import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as StyledApplicationForm from './applicationForm.styles';
import Clause from './clause/clause';
import { setApplicationLevel } from '../../actions/applicationActions';
import ApplicationFormHeader from './applicationFormHeader/applicationFormHeader';
import { Container } from '../base';
import { animateScrollTop } from '../../helpers/scrollToTop/animateScrollTop';
import Form from './form/form';
import FormAccepted from './formAccepted';

const ApplicationForm = ({
	apartment,
	page,
	authInfo,
	applicationReducer,
	dispatch
}) => {
	const { currentLevel } = applicationReducer;

	useEffect(() => {
		// Scroll to top when a level updates
		animateScrollTop();
	}, [currentLevel]);

	const setLevel = (level) => {
		dispatch(setApplicationLevel(level));
	};

	return (
		<StyledApplicationForm.Wrapper>
			<Container>
				<ApplicationFormHeader currentLevel={currentLevel} setLevel={setLevel} />
				<StyledApplicationForm.Level>
					{
						currentLevel === 1 && (
							<Clause
								buttonText={page.Values.AcceptClauseButtonText}
								content={page.Values.Clause}
								onAccept={setLevel.bind(null, 2)} />
						)
					}
					{
						currentLevel === 2 && (
							<Form
								authInfo={authInfo}
								formIntroText={page.Values.FormIntro}
								apartment={apartment}
								applicationReducer={applicationReducer}
								dispatch={dispatch} />
						)
					}
					{
						currentLevel === 3 && (
							<FormAccepted
								title={page.Values.FormAcceptedTitle}
								content={page.Values.FormAcceptedContent}
								apartment={apartment} />
						)
					}
				</StyledApplicationForm.Level>
			</Container>
		</StyledApplicationForm.Wrapper>
	);
};

const mapStateToProps = ({ applicationReducer }) => ({
	applicationReducer
});

export default connect(mapStateToProps)(ApplicationForm);
